<template>
    <div class="onboarding-screen-panel">
        <div class="onboarding-screen-panel__overlay"></div>
        <div class="onboarding-screen-panel__container">
            <section class="onboarding-screen-panel__header">
                <h1 class="onboarding-screen-panel__header-title typographies-display-brand-large">
                    {{ $l10n.__('Votre essai gratuit Sellsy') }}
                </h1>

                <CompassButton
                    v-if="isVariationDemoButtonAtTop"
                    class="onboarding-screen-panel__header-button"
                    data-bot="ask-for-demo-top-right"
                    :label="$t.__('common.actions.ask_demo')"
                    @click="redirectTo('https://go.sellsy.com/demande-de-rendez-vous', '_blank')"
                >
                </CompassButton>

                <!-- TODO : uncomment progressbar once dynamic onboarding data
                        <CompassProgressBar :state="onboardingState" :caption="$t.__('onboarding.OnboardingScreenPanel.items_discovered')"/>
                    end to TODO-->

                <CompassIconButton icon="close" @click="close" />
            </section>
            <section class="onboarding-screen-panel__content">
                <OnboardingScreen :columns="columns" :isLoading="isLoading" />
            </section>
        </div>
    </div>
</template>

<script>
import OnboardingScreen from './OnboardingScreen.vue';
import onboardingScreenService from 'api/onboarding/onboardingScreenService';
import Feature from 'Services/Feature';

export default {
    components: { OnboardingScreen },
    data() {
        return {
            isLoading: false,
            columns: [],
        };
    },
    computed: {
        isVariationDemoButtonAtTop() {
            return Feature.isVariation('onboarding-screen-abtest-button', 'demo-button-at-top');
        },
    },
    created() {
        this.getCardsData();
    },
    methods: {
        close() {
            this.$emit('close');
        },
        redirectTo(url, target) {
            window.open(url, target);
        },
        async getCardsData() {
            this.isLoading = true;

            await onboardingScreenService
                .getCards()
                .then((response) => {
                    this.columns = response.data.columns;
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
};
</script>

<style scoped lang="scss">
.onboarding-screen-panel {
    position: fixed;
    z-index: 1000;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    &__container {
        width: 90%;
        height: 100%;
        margin-right: 0;
        margin-left: auto;
        padding: var(--spacing-6);
        background: var(--colors-common-background-default);
        overflow: auto;
    }

    &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: var(--spacing-3);
        margin-bottom: var(--spacing-4);

        &-title {
            margin-bottom: 0;
        }
        &-button {
            margin-left: auto;
        }
    }

    &__overlay {
        position: absolute;
        z-index: -1;

        width: 100%;
        height: 100%;

        background-color: var(--colors-common-background-overlay-dark);
    }
}
</style>
